// source: pbtypes/cloud/services/skygateway/zeppelin.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var pbtypes_experimental_webrtc_c_impl_webrtc_stats_pb = require('../../../../pbtypes/experimental/webrtc_c_impl/webrtc_stats_pb.js');
goog.object.extend(proto, pbtypes_experimental_webrtc_c_impl_webrtc_stats_pb);
var pbtypes_cloud_services_skygateway_iface_stats_pb = require('../../../../pbtypes/cloud/services/skygateway/iface_stats_pb.js');
goog.object.extend(proto, pbtypes_cloud_services_skygateway_iface_stats_pb);
var pbtypes_cloud_services_skygateway_device_stats_pb = require('../../../../pbtypes/cloud/services/skygateway/device_stats_pb.js');
goog.object.extend(proto, pbtypes_cloud_services_skygateway_device_stats_pb);
var pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb = require('../../../../pbtypes/cloud/services/skygateway/cloud_desired_configuration_pb.js');
goog.object.extend(proto, pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb);
goog.exportSymbol('proto.skygateway.AckedAggregatorDroppedStats', null, global);
goog.exportSymbol('proto.skygateway.AckedAggregatorStats', null, global);
goog.exportSymbol('proto.skygateway.CameraChannelSubscriptionRequest', null, global);
goog.exportSymbol('proto.skygateway.CameraChannelSubscriptionRequest.SubscriptionStatus', null, global);
goog.exportSymbol('proto.skygateway.CameraChannelSubscriptionResponse', null, global);
goog.exportSymbol('proto.skygateway.ClientStatusSpoofState', null, global);
goog.exportSymbol('proto.skygateway.ClientStatusSpoofState.Enum', null, global);
goog.exportSymbol('proto.skygateway.CloudNodeAdapterStatsReport', null, global);
goog.exportSymbol('proto.skygateway.DebugAdapterStatsReport', null, global);
goog.exportSymbol('proto.skygateway.LiveKitAdapterStatsReport', null, global);
goog.exportSymbol('proto.skygateway.LiveKitAdapterStatus', null, global);
goog.exportSymbol('proto.skygateway.LiveKitTunnelStats', null, global);
goog.exportSymbol('proto.skygateway.PilotIntent', null, global);
goog.exportSymbol('proto.skygateway.PilotIntentResponse', null, global);
goog.exportSymbol('proto.skygateway.SkyOTTunnelStatus', null, global);
goog.exportSymbol('proto.skygateway.SkybusStats', null, global);
goog.exportSymbol('proto.skygateway.TrackFormat', null, global);
goog.exportSymbol('proto.skygateway.TrackFormat.Enum', null, global);
goog.exportSymbol('proto.skygateway.ZeppelinCloudOverrides', null, global);
goog.exportSymbol('proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides', null, global);
goog.exportSymbol('proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.FusionMode', null, global);
goog.exportSymbol('proto.skygateway.ZeppelinStatsReport', null, global);
goog.exportSymbol('proto.skygateway.ZeppelinStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.TrackFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.TrackFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.TrackFormat.displayName = 'proto.skygateway.TrackFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.ClientStatusSpoofState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.ClientStatusSpoofState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.ClientStatusSpoofState.displayName = 'proto.skygateway.ClientStatusSpoofState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.LiveKitAdapterStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skygateway.LiveKitAdapterStatus.repeatedFields_, null);
};
goog.inherits(proto.skygateway.LiveKitAdapterStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.LiveKitAdapterStatus.displayName = 'proto.skygateway.LiveKitAdapterStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.LiveKitTunnelStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.LiveKitTunnelStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.LiveKitTunnelStats.displayName = 'proto.skygateway.LiveKitTunnelStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.SkyOTTunnelStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skygateway.SkyOTTunnelStatus.repeatedFields_, null);
};
goog.inherits(proto.skygateway.SkyOTTunnelStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.SkyOTTunnelStatus.displayName = 'proto.skygateway.SkyOTTunnelStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.SkybusStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.SkybusStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.SkybusStats.displayName = 'proto.skygateway.SkybusStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.AckedAggregatorDroppedStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.AckedAggregatorDroppedStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.AckedAggregatorDroppedStats.displayName = 'proto.skygateway.AckedAggregatorDroppedStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.AckedAggregatorStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.AckedAggregatorStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.AckedAggregatorStats.displayName = 'proto.skygateway.AckedAggregatorStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.LiveKitAdapterStatsReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.LiveKitAdapterStatsReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.LiveKitAdapterStatsReport.displayName = 'proto.skygateway.LiveKitAdapterStatsReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.CloudNodeAdapterStatsReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.CloudNodeAdapterStatsReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.CloudNodeAdapterStatsReport.displayName = 'proto.skygateway.CloudNodeAdapterStatsReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.DebugAdapterStatsReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.DebugAdapterStatsReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.DebugAdapterStatsReport.displayName = 'proto.skygateway.DebugAdapterStatsReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.ZeppelinStatsReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.ZeppelinStatsReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.ZeppelinStatsReport.displayName = 'proto.skygateway.ZeppelinStatsReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.ZeppelinStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.ZeppelinStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.ZeppelinStatus.displayName = 'proto.skygateway.ZeppelinStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.CameraChannelSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.CameraChannelSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.CameraChannelSubscriptionRequest.displayName = 'proto.skygateway.CameraChannelSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.CameraChannelSubscriptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.CameraChannelSubscriptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.CameraChannelSubscriptionResponse.displayName = 'proto.skygateway.CameraChannelSubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.PilotIntent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.PilotIntent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.PilotIntent.displayName = 'proto.skygateway.PilotIntent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.PilotIntentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.PilotIntentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.PilotIntentResponse.displayName = 'proto.skygateway.PilotIntentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.ZeppelinCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.ZeppelinCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.ZeppelinCloudOverrides.displayName = 'proto.skygateway.ZeppelinCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.displayName = 'proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.TrackFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.TrackFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.TrackFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.TrackFormat.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.TrackFormat}
 */
proto.skygateway.TrackFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.TrackFormat;
  return proto.skygateway.TrackFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.TrackFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.TrackFormat}
 */
proto.skygateway.TrackFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.TrackFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.TrackFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.TrackFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.TrackFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.skygateway.TrackFormat.Enum = {
  DEFAULT: 0,
  H264: 1,
  H265_8BIT: 2,
  H265_10BIT: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.ClientStatusSpoofState.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.ClientStatusSpoofState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.ClientStatusSpoofState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ClientStatusSpoofState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.ClientStatusSpoofState}
 */
proto.skygateway.ClientStatusSpoofState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.ClientStatusSpoofState;
  return proto.skygateway.ClientStatusSpoofState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.ClientStatusSpoofState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.ClientStatusSpoofState}
 */
proto.skygateway.ClientStatusSpoofState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.ClientStatusSpoofState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.ClientStatusSpoofState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.ClientStatusSpoofState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ClientStatusSpoofState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.skygateway.ClientStatusSpoofState.Enum = {
  UNKOWN: 0,
  NONE: 1,
  EMPTY: 2,
  PILOT_INTENT: 3
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skygateway.LiveKitAdapterStatus.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.LiveKitAdapterStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.LiveKitAdapterStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.LiveKitAdapterStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
currentPilotClientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
tunnelOpen: jspb.Message.getFieldWithDefault(msg, 2, ""),
lastPilotRequestUclock: jspb.Message.getFieldWithDefault(msg, 3, 0),
trackFormat: jspb.Message.getFieldWithDefault(msg, 6, 0),
clientStatusSpoofState: jspb.Message.getFieldWithDefault(msg, 9, 0),
identityClientIdMapMap: (f = msg.getIdentityClientIdMapMap()) ? f.toObject(includeInstance, undefined) : [],
clientIdLastContactMapMap: (f = msg.getClientIdLastContactMapMap()) ? f.toObject(includeInstance, undefined) : [],
clientIdIntentTtlMapMap: (f = msg.getClientIdIntentTtlMapMap()) ? f.toObject(includeInstance, undefined) : [],
localTunnelSubscriptionsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.LiveKitAdapterStatus}
 */
proto.skygateway.LiveKitAdapterStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.LiveKitAdapterStatus;
  return proto.skygateway.LiveKitAdapterStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.LiveKitAdapterStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.LiveKitAdapterStatus}
 */
proto.skygateway.LiveKitAdapterStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrentPilotClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTunnelOpen(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLastPilotRequestUclock(value);
      break;
    case 6:
      var value = /** @type {!proto.skygateway.TrackFormat.Enum} */ (reader.readEnum());
      msg.setTrackFormat(value);
      break;
    case 9:
      var value = /** @type {!proto.skygateway.ClientStatusSpoofState.Enum} */ (reader.readEnum());
      msg.setClientStatusSpoofState(value);
      break;
    case 4:
      var value = msg.getIdentityClientIdMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readStringRequireUtf8, null, "", "");
         });
      break;
    case 7:
      var value = msg.getClientIdLastContactMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readInt64, null, "", 0);
         });
      break;
    case 8:
      var value = msg.getClientIdIntentTtlMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readInt64, null, "", 0);
         });
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addLocalTunnelSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.LiveKitAdapterStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.LiveKitAdapterStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.LiveKitAdapterStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPilotClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTunnelOpen();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastPilotRequestUclock();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTrackFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getClientStatusSpoofState();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getIdentityClientIdMapMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getIdentityClientIdMapMap(true),
    4,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getClientIdLastContactMapMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getClientIdLastContactMapMap(true),
    7,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeInt64);
  }
  f = message.getClientIdIntentTtlMapMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getClientIdIntentTtlMapMap(true),
    8,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeInt64);
  }
  f = message.getLocalTunnelSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string current_pilot_client_id = 1;
 * @return {string}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getCurrentPilotClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.setCurrentPilotClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tunnel_open = 2;
 * @return {string}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getTunnelOpen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.setTunnelOpen = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 last_pilot_request_uclock = 3;
 * @return {number}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getLastPilotRequestUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.setLastPilotRequestUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional TrackFormat.Enum track_format = 6;
 * @return {!proto.skygateway.TrackFormat.Enum}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getTrackFormat = function() {
  return /** @type {!proto.skygateway.TrackFormat.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.skygateway.TrackFormat.Enum} value
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.setTrackFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional ClientStatusSpoofState.Enum client_status_spoof_state = 9;
 * @return {!proto.skygateway.ClientStatusSpoofState.Enum}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getClientStatusSpoofState = function() {
  return /** @type {!proto.skygateway.ClientStatusSpoofState.Enum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.skygateway.ClientStatusSpoofState.Enum} value
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.setClientStatusSpoofState = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * map<string, string> identity_client_id_map = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getIdentityClientIdMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.clearIdentityClientIdMapMap = function() {
  this.getIdentityClientIdMapMap().clear();
  return this;
};


/**
 * map<string, int64> client_id_last_contact_map = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getClientIdLastContactMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.clearClientIdLastContactMapMap = function() {
  this.getClientIdLastContactMapMap().clear();
  return this;
};


/**
 * map<string, int64> client_id_intent_ttl_map = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getClientIdIntentTtlMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.clearClientIdIntentTtlMapMap = function() {
  this.getClientIdIntentTtlMapMap().clear();
  return this;
};


/**
 * repeated string local_tunnel_subscriptions = 5;
 * @return {!Array<string>}
 */
proto.skygateway.LiveKitAdapterStatus.prototype.getLocalTunnelSubscriptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.setLocalTunnelSubscriptionsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.addLocalTunnelSubscriptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skygateway.LiveKitAdapterStatus} returns this
 */
proto.skygateway.LiveKitAdapterStatus.prototype.clearLocalTunnelSubscriptionsList = function() {
  return this.setLocalTunnelSubscriptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.LiveKitTunnelStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.LiveKitTunnelStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.LiveKitTunnelStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.LiveKitTunnelStats.toObject = function(includeInstance, msg) {
  var f, obj = {
tunnelOpen: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
currentPilotClientId: jspb.Message.getFieldWithDefault(msg, 2, ""),
currentPilotIdentity: jspb.Message.getFieldWithDefault(msg, 3, ""),
trackStatsMap: (f = msg.getTrackStatsMap()) ? f.toObject(includeInstance, proto.webrtc.StreamStats.toObject) : [],
totalRxPackets: jspb.Message.getFieldWithDefault(msg, 5, 0),
rxChannelPacketsMap: (f = msg.getRxChannelPacketsMap()) ? f.toObject(includeInstance, undefined) : [],
totalTxPackets: jspb.Message.getFieldWithDefault(msg, 7, 0),
txChannelPacketsMap: (f = msg.getTxChannelPacketsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.LiveKitTunnelStats}
 */
proto.skygateway.LiveKitTunnelStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.LiveKitTunnelStats;
  return proto.skygateway.LiveKitTunnelStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.LiveKitTunnelStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.LiveKitTunnelStats}
 */
proto.skygateway.LiveKitTunnelStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTunnelOpen(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrentPilotClientId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrentPilotIdentity(value);
      break;
    case 4:
      var value = msg.getTrackStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.webrtc.StreamStats.deserializeBinaryFromReader, "", new proto.webrtc.StreamStats());
         });
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRxPackets(value);
      break;
    case 6:
      var value = msg.getRxChannelPacketsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalTxPackets(value);
      break;
    case 8:
      var value = msg.getTxChannelPacketsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.LiveKitTunnelStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.LiveKitTunnelStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.LiveKitTunnelStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.LiveKitTunnelStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTunnelOpen();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCurrentPilotClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrentPilotIdentity();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTrackStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getTrackStatsMap(true),
    4,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.webrtc.StreamStats.serializeBinaryToWriter);
  }
  f = message.getTotalRxPackets();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getRxChannelPacketsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getRxChannelPacketsMap(true),
    6,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getTotalTxPackets();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getTxChannelPacketsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getTxChannelPacketsMap(true),
    8,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * optional bool tunnel_open = 1;
 * @return {boolean}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getTunnelOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.setTunnelOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string current_pilot_client_id = 2;
 * @return {string}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getCurrentPilotClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.setCurrentPilotClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string current_pilot_identity = 3;
 * @return {string}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getCurrentPilotIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.setCurrentPilotIdentity = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, webrtc.StreamStats> track_stats = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.webrtc.StreamStats>}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getTrackStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.webrtc.StreamStats>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.webrtc.StreamStats));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.clearTrackStatsMap = function() {
  this.getTrackStatsMap().clear();
  return this;
};


/**
 * optional uint32 total_rx_packets = 5;
 * @return {number}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getTotalRxPackets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.setTotalRxPackets = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * map<string, uint32> rx_channel_packets = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getRxChannelPacketsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.clearRxChannelPacketsMap = function() {
  this.getRxChannelPacketsMap().clear();
  return this;
};


/**
 * optional uint32 total_tx_packets = 7;
 * @return {number}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getTotalTxPackets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.setTotalTxPackets = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * map<string, uint32> tx_channel_packets = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.LiveKitTunnelStats.prototype.getTxChannelPacketsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.LiveKitTunnelStats} returns this
 */
proto.skygateway.LiveKitTunnelStats.prototype.clearTxChannelPacketsMap = function() {
  this.getTxChannelPacketsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skygateway.SkyOTTunnelStatus.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.SkyOTTunnelStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.SkyOTTunnelStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.SkyOTTunnelStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.SkyOTTunnelStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
localTunnelSubscriptionsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.SkyOTTunnelStatus}
 */
proto.skygateway.SkyOTTunnelStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.SkyOTTunnelStatus;
  return proto.skygateway.SkyOTTunnelStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.SkyOTTunnelStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.SkyOTTunnelStatus}
 */
proto.skygateway.SkyOTTunnelStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addLocalTunnelSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.SkyOTTunnelStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.SkyOTTunnelStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.SkyOTTunnelStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.SkyOTTunnelStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocalTunnelSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * repeated string local_tunnel_subscriptions = 5;
 * @return {!Array<string>}
 */
proto.skygateway.SkyOTTunnelStatus.prototype.getLocalTunnelSubscriptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.skygateway.SkyOTTunnelStatus} returns this
 */
proto.skygateway.SkyOTTunnelStatus.prototype.setLocalTunnelSubscriptionsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.skygateway.SkyOTTunnelStatus} returns this
 */
proto.skygateway.SkyOTTunnelStatus.prototype.addLocalTunnelSubscriptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skygateway.SkyOTTunnelStatus} returns this
 */
proto.skygateway.SkyOTTunnelStatus.prototype.clearLocalTunnelSubscriptionsList = function() {
  return this.setLocalTunnelSubscriptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.SkybusStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.SkybusStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.SkybusStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.SkybusStats.toObject = function(includeInstance, msg) {
  var f, obj = {
channelMessageStatsMap: (f = msg.getChannelMessageStatsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.SkybusStats}
 */
proto.skygateway.SkybusStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.SkybusStats;
  return proto.skygateway.SkybusStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.SkybusStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.SkybusStats}
 */
proto.skygateway.SkybusStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getChannelMessageStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.SkybusStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.SkybusStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.SkybusStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.SkybusStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelMessageStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getChannelMessageStatsMap(true),
    1,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * map<string, uint32> channel_message_stats = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.SkybusStats.prototype.getChannelMessageStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.SkybusStats} returns this
 */
proto.skygateway.SkybusStats.prototype.clearChannelMessageStatsMap = function() {
  this.getChannelMessageStatsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.AckedAggregatorDroppedStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.AckedAggregatorDroppedStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AckedAggregatorDroppedStats.toObject = function(includeInstance, msg) {
  var f, obj = {
maxMessageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
isFlying: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
oversizedMessageStatsMap: (f = msg.getOversizedMessageStatsMap()) ? f.toObject(includeInstance, undefined) : [],
groundOnlyMessageStatsMap: (f = msg.getGroundOnlyMessageStatsMap()) ? f.toObject(includeInstance, undefined) : [],
pilotOnlyMessageStatsMap: (f = msg.getPilotOnlyMessageStatsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.AckedAggregatorDroppedStats}
 */
proto.skygateway.AckedAggregatorDroppedStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.AckedAggregatorDroppedStats;
  return proto.skygateway.AckedAggregatorDroppedStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.AckedAggregatorDroppedStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.AckedAggregatorDroppedStats}
 */
proto.skygateway.AckedAggregatorDroppedStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxMessageSize(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFlying(value);
      break;
    case 1:
      var value = msg.getOversizedMessageStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 2:
      var value = msg.getGroundOnlyMessageStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 3:
      var value = msg.getPilotOnlyMessageStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.AckedAggregatorDroppedStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.AckedAggregatorDroppedStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AckedAggregatorDroppedStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxMessageSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getIsFlying();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getOversizedMessageStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getOversizedMessageStatsMap(true),
    1,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getGroundOnlyMessageStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getGroundOnlyMessageStatsMap(true),
    2,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getPilotOnlyMessageStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getPilotOnlyMessageStatsMap(true),
    3,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * optional uint32 max_message_size = 4;
 * @return {number}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.getMaxMessageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AckedAggregatorDroppedStats} returns this
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.setMaxMessageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_flying = 5;
 * @return {boolean}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.getIsFlying = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skygateway.AckedAggregatorDroppedStats} returns this
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.setIsFlying = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * map<string, uint32> oversized_message_stats = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.getOversizedMessageStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.AckedAggregatorDroppedStats} returns this
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.clearOversizedMessageStatsMap = function() {
  this.getOversizedMessageStatsMap().clear();
  return this;
};


/**
 * map<string, uint32> ground_only_message_stats = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.getGroundOnlyMessageStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.AckedAggregatorDroppedStats} returns this
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.clearGroundOnlyMessageStatsMap = function() {
  this.getGroundOnlyMessageStatsMap().clear();
  return this;
};


/**
 * map<string, uint32> pilot_only_message_stats = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.getPilotOnlyMessageStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.AckedAggregatorDroppedStats} returns this
 */
proto.skygateway.AckedAggregatorDroppedStats.prototype.clearPilotOnlyMessageStatsMap = function() {
  this.getPilotOnlyMessageStatsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.AckedAggregatorStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.AckedAggregatorStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.AckedAggregatorStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AckedAggregatorStats.toObject = function(includeInstance, msg) {
  var f, obj = {
droppedMessageStats: (f = msg.getDroppedMessageStats()) && proto.skygateway.AckedAggregatorDroppedStats.toObject(includeInstance, f),
scheduledMessageStatsMap: (f = msg.getScheduledMessageStatsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.AckedAggregatorStats}
 */
proto.skygateway.AckedAggregatorStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.AckedAggregatorStats;
  return proto.skygateway.AckedAggregatorStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.AckedAggregatorStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.AckedAggregatorStats}
 */
proto.skygateway.AckedAggregatorStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skygateway.AckedAggregatorDroppedStats;
      reader.readMessage(value,proto.skygateway.AckedAggregatorDroppedStats.deserializeBinaryFromReader);
      msg.setDroppedMessageStats(value);
      break;
    case 2:
      var value = msg.getScheduledMessageStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.AckedAggregatorStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.AckedAggregatorStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.AckedAggregatorStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AckedAggregatorStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDroppedMessageStats();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skygateway.AckedAggregatorDroppedStats.serializeBinaryToWriter
    );
  }
  f = message.getScheduledMessageStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getScheduledMessageStatsMap(true),
    2,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * optional AckedAggregatorDroppedStats dropped_message_stats = 1;
 * @return {?proto.skygateway.AckedAggregatorDroppedStats}
 */
proto.skygateway.AckedAggregatorStats.prototype.getDroppedMessageStats = function() {
  return /** @type{?proto.skygateway.AckedAggregatorDroppedStats} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.AckedAggregatorDroppedStats, 1));
};


/**
 * @param {?proto.skygateway.AckedAggregatorDroppedStats|undefined} value
 * @return {!proto.skygateway.AckedAggregatorStats} returns this
*/
proto.skygateway.AckedAggregatorStats.prototype.setDroppedMessageStats = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.AckedAggregatorStats} returns this
 */
proto.skygateway.AckedAggregatorStats.prototype.clearDroppedMessageStats = function() {
  return this.setDroppedMessageStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.AckedAggregatorStats.prototype.hasDroppedMessageStats = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, uint32> scheduled_message_stats = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.AckedAggregatorStats.prototype.getScheduledMessageStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.AckedAggregatorStats} returns this
 */
proto.skygateway.AckedAggregatorStats.prototype.clearScheduledMessageStatsMap = function() {
  this.getScheduledMessageStatsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.LiveKitAdapterStatsReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.LiveKitAdapterStatsReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.LiveKitAdapterStatsReport.toObject = function(includeInstance, msg) {
  var f, obj = {
tunnelStats: (f = msg.getTunnelStats()) && proto.skygateway.LiveKitTunnelStats.toObject(includeInstance, f),
adapterStatus: (f = msg.getAdapterStatus()) && proto.skygateway.LiveKitAdapterStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.LiveKitAdapterStatsReport}
 */
proto.skygateway.LiveKitAdapterStatsReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.LiveKitAdapterStatsReport;
  return proto.skygateway.LiveKitAdapterStatsReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.LiveKitAdapterStatsReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.LiveKitAdapterStatsReport}
 */
proto.skygateway.LiveKitAdapterStatsReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skygateway.LiveKitTunnelStats;
      reader.readMessage(value,proto.skygateway.LiveKitTunnelStats.deserializeBinaryFromReader);
      msg.setTunnelStats(value);
      break;
    case 2:
      var value = new proto.skygateway.LiveKitAdapterStatus;
      reader.readMessage(value,proto.skygateway.LiveKitAdapterStatus.deserializeBinaryFromReader);
      msg.setAdapterStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.LiveKitAdapterStatsReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.LiveKitAdapterStatsReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.LiveKitAdapterStatsReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTunnelStats();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skygateway.LiveKitTunnelStats.serializeBinaryToWriter
    );
  }
  f = message.getAdapterStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skygateway.LiveKitAdapterStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional LiveKitTunnelStats tunnel_stats = 1;
 * @return {?proto.skygateway.LiveKitTunnelStats}
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.getTunnelStats = function() {
  return /** @type{?proto.skygateway.LiveKitTunnelStats} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.LiveKitTunnelStats, 1));
};


/**
 * @param {?proto.skygateway.LiveKitTunnelStats|undefined} value
 * @return {!proto.skygateway.LiveKitAdapterStatsReport} returns this
*/
proto.skygateway.LiveKitAdapterStatsReport.prototype.setTunnelStats = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.LiveKitAdapterStatsReport} returns this
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.clearTunnelStats = function() {
  return this.setTunnelStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.hasTunnelStats = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LiveKitAdapterStatus adapter_status = 2;
 * @return {?proto.skygateway.LiveKitAdapterStatus}
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.getAdapterStatus = function() {
  return /** @type{?proto.skygateway.LiveKitAdapterStatus} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.LiveKitAdapterStatus, 2));
};


/**
 * @param {?proto.skygateway.LiveKitAdapterStatus|undefined} value
 * @return {!proto.skygateway.LiveKitAdapterStatsReport} returns this
*/
proto.skygateway.LiveKitAdapterStatsReport.prototype.setAdapterStatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.LiveKitAdapterStatsReport} returns this
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.clearAdapterStatus = function() {
  return this.setAdapterStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.LiveKitAdapterStatsReport.prototype.hasAdapterStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.CloudNodeAdapterStatsReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.CloudNodeAdapterStatsReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.CloudNodeAdapterStatsReport.toObject = function(includeInstance, msg) {
  var f, obj = {
devicePeerStats: (f = msg.getDevicePeerStats()) && pbtypes_cloud_services_skygateway_device_stats_pb.AggregateDeviceStats.toObject(includeInstance, f),
otherPeerStatsMap: (f = msg.getOtherPeerStatsMap()) ? f.toObject(includeInstance, proto.skygateway.AggregateDeviceStats.toObject) : [],
interfaceStatsMap: (f = msg.getInterfaceStatsMap()) ? f.toObject(includeInstance, proto.skygateway.AggregateInterfaceStats.toObject) : [],
cloudDesiredConfiguration: (f = msg.getCloudDesiredConfiguration()) && pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb.CloudDesiredConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport}
 */
proto.skygateway.CloudNodeAdapterStatsReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.CloudNodeAdapterStatsReport;
  return proto.skygateway.CloudNodeAdapterStatsReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.CloudNodeAdapterStatsReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport}
 */
proto.skygateway.CloudNodeAdapterStatsReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_cloud_services_skygateway_device_stats_pb.AggregateDeviceStats;
      reader.readMessage(value,pbtypes_cloud_services_skygateway_device_stats_pb.AggregateDeviceStats.deserializeBinaryFromReader);
      msg.setDevicePeerStats(value);
      break;
    case 2:
      var value = msg.getOtherPeerStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.skygateway.AggregateDeviceStats.deserializeBinaryFromReader, "", new proto.skygateway.AggregateDeviceStats());
         });
      break;
    case 3:
      var value = msg.getInterfaceStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.skygateway.AggregateInterfaceStats.deserializeBinaryFromReader, "", new proto.skygateway.AggregateInterfaceStats());
         });
      break;
    case 4:
      var value = new pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb.CloudDesiredConfiguration;
      reader.readMessage(value,pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb.CloudDesiredConfiguration.deserializeBinaryFromReader);
      msg.setCloudDesiredConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.CloudNodeAdapterStatsReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.CloudNodeAdapterStatsReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.CloudNodeAdapterStatsReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicePeerStats();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_cloud_services_skygateway_device_stats_pb.AggregateDeviceStats.serializeBinaryToWriter
    );
  }
  f = message.getOtherPeerStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getOtherPeerStatsMap(true),
    2,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.skygateway.AggregateDeviceStats.serializeBinaryToWriter);
  }
  f = message.getInterfaceStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getInterfaceStatsMap(true),
    3,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.skygateway.AggregateInterfaceStats.serializeBinaryToWriter);
  }
  f = message.getCloudDesiredConfiguration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb.CloudDesiredConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional AggregateDeviceStats device_peer_stats = 1;
 * @return {?proto.skygateway.AggregateDeviceStats}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.getDevicePeerStats = function() {
  return /** @type{?proto.skygateway.AggregateDeviceStats} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skygateway_device_stats_pb.AggregateDeviceStats, 1));
};


/**
 * @param {?proto.skygateway.AggregateDeviceStats|undefined} value
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport} returns this
*/
proto.skygateway.CloudNodeAdapterStatsReport.prototype.setDevicePeerStats = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport} returns this
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.clearDevicePeerStats = function() {
  return this.setDevicePeerStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.hasDevicePeerStats = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, AggregateDeviceStats> other_peer_stats = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.skygateway.AggregateDeviceStats>}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.getOtherPeerStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.skygateway.AggregateDeviceStats>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.skygateway.AggregateDeviceStats));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport} returns this
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.clearOtherPeerStatsMap = function() {
  this.getOtherPeerStatsMap().clear();
  return this;
};


/**
 * map<string, AggregateInterfaceStats> interface_stats = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.skygateway.AggregateInterfaceStats>}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.getInterfaceStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.skygateway.AggregateInterfaceStats>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.skygateway.AggregateInterfaceStats));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport} returns this
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.clearInterfaceStatsMap = function() {
  this.getInterfaceStatsMap().clear();
  return this;
};


/**
 * optional CloudDesiredConfiguration cloud_desired_configuration = 4;
 * @return {?proto.skygateway.CloudDesiredConfiguration}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.getCloudDesiredConfiguration = function() {
  return /** @type{?proto.skygateway.CloudDesiredConfiguration} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skygateway_cloud_desired_configuration_pb.CloudDesiredConfiguration, 4));
};


/**
 * @param {?proto.skygateway.CloudDesiredConfiguration|undefined} value
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport} returns this
*/
proto.skygateway.CloudNodeAdapterStatsReport.prototype.setCloudDesiredConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.CloudNodeAdapterStatsReport} returns this
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.clearCloudDesiredConfiguration = function() {
  return this.setCloudDesiredConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.CloudNodeAdapterStatsReport.prototype.hasCloudDesiredConfiguration = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.DebugAdapterStatsReport.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.DebugAdapterStatsReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.DebugAdapterStatsReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DebugAdapterStatsReport.toObject = function(includeInstance, msg) {
  var f, obj = {
ackedAggregatorStats: (f = msg.getAckedAggregatorStats()) && proto.skygateway.AckedAggregatorStats.toObject(includeInstance, f),
skybusStats: (f = msg.getSkybusStats()) && proto.skygateway.SkybusStats.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.DebugAdapterStatsReport}
 */
proto.skygateway.DebugAdapterStatsReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.DebugAdapterStatsReport;
  return proto.skygateway.DebugAdapterStatsReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.DebugAdapterStatsReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.DebugAdapterStatsReport}
 */
proto.skygateway.DebugAdapterStatsReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skygateway.AckedAggregatorStats;
      reader.readMessage(value,proto.skygateway.AckedAggregatorStats.deserializeBinaryFromReader);
      msg.setAckedAggregatorStats(value);
      break;
    case 2:
      var value = new proto.skygateway.SkybusStats;
      reader.readMessage(value,proto.skygateway.SkybusStats.deserializeBinaryFromReader);
      msg.setSkybusStats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.DebugAdapterStatsReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.DebugAdapterStatsReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.DebugAdapterStatsReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DebugAdapterStatsReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAckedAggregatorStats();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skygateway.AckedAggregatorStats.serializeBinaryToWriter
    );
  }
  f = message.getSkybusStats();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skygateway.SkybusStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional AckedAggregatorStats acked_aggregator_stats = 1;
 * @return {?proto.skygateway.AckedAggregatorStats}
 */
proto.skygateway.DebugAdapterStatsReport.prototype.getAckedAggregatorStats = function() {
  return /** @type{?proto.skygateway.AckedAggregatorStats} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.AckedAggregatorStats, 1));
};


/**
 * @param {?proto.skygateway.AckedAggregatorStats|undefined} value
 * @return {!proto.skygateway.DebugAdapterStatsReport} returns this
*/
proto.skygateway.DebugAdapterStatsReport.prototype.setAckedAggregatorStats = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.DebugAdapterStatsReport} returns this
 */
proto.skygateway.DebugAdapterStatsReport.prototype.clearAckedAggregatorStats = function() {
  return this.setAckedAggregatorStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.DebugAdapterStatsReport.prototype.hasAckedAggregatorStats = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SkybusStats skybus_stats = 2;
 * @return {?proto.skygateway.SkybusStats}
 */
proto.skygateway.DebugAdapterStatsReport.prototype.getSkybusStats = function() {
  return /** @type{?proto.skygateway.SkybusStats} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.SkybusStats, 2));
};


/**
 * @param {?proto.skygateway.SkybusStats|undefined} value
 * @return {!proto.skygateway.DebugAdapterStatsReport} returns this
*/
proto.skygateway.DebugAdapterStatsReport.prototype.setSkybusStats = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.DebugAdapterStatsReport} returns this
 */
proto.skygateway.DebugAdapterStatsReport.prototype.clearSkybusStats = function() {
  return this.setSkybusStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.DebugAdapterStatsReport.prototype.hasSkybusStats = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.ZeppelinStatsReport.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.ZeppelinStatsReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.ZeppelinStatsReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinStatsReport.toObject = function(includeInstance, msg) {
  var f, obj = {
livekitAdapterStatsReport: (f = msg.getLivekitAdapterStatsReport()) && proto.skygateway.LiveKitAdapterStatsReport.toObject(includeInstance, f),
cloudNodeAdapterStatsReport: (f = msg.getCloudNodeAdapterStatsReport()) && proto.skygateway.CloudNodeAdapterStatsReport.toObject(includeInstance, f),
debugAdapterStatsReport: (f = msg.getDebugAdapterStatsReport()) && proto.skygateway.DebugAdapterStatsReport.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.ZeppelinStatsReport}
 */
proto.skygateway.ZeppelinStatsReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.ZeppelinStatsReport;
  return proto.skygateway.ZeppelinStatsReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.ZeppelinStatsReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.ZeppelinStatsReport}
 */
proto.skygateway.ZeppelinStatsReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skygateway.LiveKitAdapterStatsReport;
      reader.readMessage(value,proto.skygateway.LiveKitAdapterStatsReport.deserializeBinaryFromReader);
      msg.setLivekitAdapterStatsReport(value);
      break;
    case 2:
      var value = new proto.skygateway.CloudNodeAdapterStatsReport;
      reader.readMessage(value,proto.skygateway.CloudNodeAdapterStatsReport.deserializeBinaryFromReader);
      msg.setCloudNodeAdapterStatsReport(value);
      break;
    case 3:
      var value = new proto.skygateway.DebugAdapterStatsReport;
      reader.readMessage(value,proto.skygateway.DebugAdapterStatsReport.deserializeBinaryFromReader);
      msg.setDebugAdapterStatsReport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.ZeppelinStatsReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.ZeppelinStatsReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.ZeppelinStatsReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinStatsReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLivekitAdapterStatsReport();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skygateway.LiveKitAdapterStatsReport.serializeBinaryToWriter
    );
  }
  f = message.getCloudNodeAdapterStatsReport();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skygateway.CloudNodeAdapterStatsReport.serializeBinaryToWriter
    );
  }
  f = message.getDebugAdapterStatsReport();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.skygateway.DebugAdapterStatsReport.serializeBinaryToWriter
    );
  }
};


/**
 * optional LiveKitAdapterStatsReport livekit_adapter_stats_report = 1;
 * @return {?proto.skygateway.LiveKitAdapterStatsReport}
 */
proto.skygateway.ZeppelinStatsReport.prototype.getLivekitAdapterStatsReport = function() {
  return /** @type{?proto.skygateway.LiveKitAdapterStatsReport} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.LiveKitAdapterStatsReport, 1));
};


/**
 * @param {?proto.skygateway.LiveKitAdapterStatsReport|undefined} value
 * @return {!proto.skygateway.ZeppelinStatsReport} returns this
*/
proto.skygateway.ZeppelinStatsReport.prototype.setLivekitAdapterStatsReport = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.ZeppelinStatsReport} returns this
 */
proto.skygateway.ZeppelinStatsReport.prototype.clearLivekitAdapterStatsReport = function() {
  return this.setLivekitAdapterStatsReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.ZeppelinStatsReport.prototype.hasLivekitAdapterStatsReport = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CloudNodeAdapterStatsReport cloud_node_adapter_stats_report = 2;
 * @return {?proto.skygateway.CloudNodeAdapterStatsReport}
 */
proto.skygateway.ZeppelinStatsReport.prototype.getCloudNodeAdapterStatsReport = function() {
  return /** @type{?proto.skygateway.CloudNodeAdapterStatsReport} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.CloudNodeAdapterStatsReport, 2));
};


/**
 * @param {?proto.skygateway.CloudNodeAdapterStatsReport|undefined} value
 * @return {!proto.skygateway.ZeppelinStatsReport} returns this
*/
proto.skygateway.ZeppelinStatsReport.prototype.setCloudNodeAdapterStatsReport = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.ZeppelinStatsReport} returns this
 */
proto.skygateway.ZeppelinStatsReport.prototype.clearCloudNodeAdapterStatsReport = function() {
  return this.setCloudNodeAdapterStatsReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.ZeppelinStatsReport.prototype.hasCloudNodeAdapterStatsReport = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DebugAdapterStatsReport debug_adapter_stats_report = 3;
 * @return {?proto.skygateway.DebugAdapterStatsReport}
 */
proto.skygateway.ZeppelinStatsReport.prototype.getDebugAdapterStatsReport = function() {
  return /** @type{?proto.skygateway.DebugAdapterStatsReport} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.DebugAdapterStatsReport, 3));
};


/**
 * @param {?proto.skygateway.DebugAdapterStatsReport|undefined} value
 * @return {!proto.skygateway.ZeppelinStatsReport} returns this
*/
proto.skygateway.ZeppelinStatsReport.prototype.setDebugAdapterStatsReport = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.ZeppelinStatsReport} returns this
 */
proto.skygateway.ZeppelinStatsReport.prototype.clearDebugAdapterStatsReport = function() {
  return this.setDebugAdapterStatsReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.ZeppelinStatsReport.prototype.hasDebugAdapterStatsReport = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.ZeppelinStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.ZeppelinStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.ZeppelinStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
virtualSerial: jspb.Message.getFieldWithDefault(msg, 1, ""),
deviceSerial: jspb.Message.getFieldWithDefault(msg, 2, ""),
statsReport: (f = msg.getStatsReport()) && proto.skygateway.ZeppelinStatsReport.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.ZeppelinStatus}
 */
proto.skygateway.ZeppelinStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.ZeppelinStatus;
  return proto.skygateway.ZeppelinStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.ZeppelinStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.ZeppelinStatus}
 */
proto.skygateway.ZeppelinStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVirtualSerial(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDeviceSerial(value);
      break;
    case 3:
      var value = new proto.skygateway.ZeppelinStatsReport;
      reader.readMessage(value,proto.skygateway.ZeppelinStatsReport.deserializeBinaryFromReader);
      msg.setStatsReport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.ZeppelinStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.ZeppelinStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.ZeppelinStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVirtualSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeviceSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatsReport();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.skygateway.ZeppelinStatsReport.serializeBinaryToWriter
    );
  }
};


/**
 * optional string virtual_serial = 1;
 * @return {string}
 */
proto.skygateway.ZeppelinStatus.prototype.getVirtualSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.ZeppelinStatus} returns this
 */
proto.skygateway.ZeppelinStatus.prototype.setVirtualSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string device_serial = 2;
 * @return {string}
 */
proto.skygateway.ZeppelinStatus.prototype.getDeviceSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.ZeppelinStatus} returns this
 */
proto.skygateway.ZeppelinStatus.prototype.setDeviceSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ZeppelinStatsReport stats_report = 3;
 * @return {?proto.skygateway.ZeppelinStatsReport}
 */
proto.skygateway.ZeppelinStatus.prototype.getStatsReport = function() {
  return /** @type{?proto.skygateway.ZeppelinStatsReport} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.ZeppelinStatsReport, 3));
};


/**
 * @param {?proto.skygateway.ZeppelinStatsReport|undefined} value
 * @return {!proto.skygateway.ZeppelinStatus} returns this
*/
proto.skygateway.ZeppelinStatus.prototype.setStatsReport = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.ZeppelinStatus} returns this
 */
proto.skygateway.ZeppelinStatus.prototype.clearStatsReport = function() {
  return this.setStatsReport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.ZeppelinStatus.prototype.hasStatsReport = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.CameraChannelSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.CameraChannelSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.CameraChannelSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.CameraChannelSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
channel: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.CameraChannelSubscriptionRequest}
 */
proto.skygateway.CameraChannelSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.CameraChannelSubscriptionRequest;
  return proto.skygateway.CameraChannelSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.CameraChannelSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.CameraChannelSubscriptionRequest}
 */
proto.skygateway.CameraChannelSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setChannel(value);
      break;
    case 2:
      var value = /** @type {!proto.skygateway.CameraChannelSubscriptionRequest.SubscriptionStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.CameraChannelSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.CameraChannelSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.CameraChannelSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.CameraChannelSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.skygateway.CameraChannelSubscriptionRequest.SubscriptionStatus = {
  UNKNOWN: 0,
  ON: 1,
  OFF: 2
};

/**
 * optional string channel = 1;
 * @return {string}
 */
proto.skygateway.CameraChannelSubscriptionRequest.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.CameraChannelSubscriptionRequest} returns this
 */
proto.skygateway.CameraChannelSubscriptionRequest.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionStatus status = 2;
 * @return {!proto.skygateway.CameraChannelSubscriptionRequest.SubscriptionStatus}
 */
proto.skygateway.CameraChannelSubscriptionRequest.prototype.getStatus = function() {
  return /** @type {!proto.skygateway.CameraChannelSubscriptionRequest.SubscriptionStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.skygateway.CameraChannelSubscriptionRequest.SubscriptionStatus} value
 * @return {!proto.skygateway.CameraChannelSubscriptionRequest} returns this
 */
proto.skygateway.CameraChannelSubscriptionRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.CameraChannelSubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.CameraChannelSubscriptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.CameraChannelSubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.CameraChannelSubscriptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
changed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.CameraChannelSubscriptionResponse}
 */
proto.skygateway.CameraChannelSubscriptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.CameraChannelSubscriptionResponse;
  return proto.skygateway.CameraChannelSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.CameraChannelSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.CameraChannelSubscriptionResponse}
 */
proto.skygateway.CameraChannelSubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setChanged(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.CameraChannelSubscriptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.CameraChannelSubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.CameraChannelSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.CameraChannelSubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChanged();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool changed = 1;
 * @return {boolean}
 */
proto.skygateway.CameraChannelSubscriptionResponse.prototype.getChanged = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skygateway.CameraChannelSubscriptionResponse} returns this
 */
proto.skygateway.CameraChannelSubscriptionResponse.prototype.setChanged = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.PilotIntent.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.PilotIntent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.PilotIntent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.PilotIntent.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
expiry: (f = msg.getExpiry()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.PilotIntent}
 */
proto.skygateway.PilotIntent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.PilotIntent;
  return proto.skygateway.PilotIntent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.PilotIntent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.PilotIntent}
 */
proto.skygateway.PilotIntent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.PilotIntent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.PilotIntent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.PilotIntent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.PilotIntent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiry();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.skygateway.PilotIntent.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.PilotIntent} returns this
 */
proto.skygateway.PilotIntent.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp expiry = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.skygateway.PilotIntent.prototype.getExpiry = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.skygateway.PilotIntent} returns this
*/
proto.skygateway.PilotIntent.prototype.setExpiry = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.PilotIntent} returns this
 */
proto.skygateway.PilotIntent.prototype.clearExpiry = function() {
  return this.setExpiry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.PilotIntent.prototype.hasExpiry = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.PilotIntentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.PilotIntentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.PilotIntentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.PilotIntentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
granted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
rejectionReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.PilotIntentResponse}
 */
proto.skygateway.PilotIntentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.PilotIntentResponse;
  return proto.skygateway.PilotIntentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.PilotIntentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.PilotIntentResponse}
 */
proto.skygateway.PilotIntentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGranted(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRejectionReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.PilotIntentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.PilotIntentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.PilotIntentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.PilotIntentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGranted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool granted = 1;
 * @return {boolean}
 */
proto.skygateway.PilotIntentResponse.prototype.getGranted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skygateway.PilotIntentResponse} returns this
 */
proto.skygateway.PilotIntentResponse.prototype.setGranted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string rejection_reason = 2;
 * @return {string}
 */
proto.skygateway.PilotIntentResponse.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.PilotIntentResponse} returns this
 */
proto.skygateway.PilotIntentResponse.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.ZeppelinCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.ZeppelinCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceNodeOverrides: (f = msg.getDeviceNodeOverrides()) && proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.toObject(includeInstance, f),
forceCloudLog: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.ZeppelinCloudOverrides}
 */
proto.skygateway.ZeppelinCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.ZeppelinCloudOverrides;
  return proto.skygateway.ZeppelinCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.ZeppelinCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.ZeppelinCloudOverrides}
 */
proto.skygateway.ZeppelinCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides;
      reader.readMessage(value,proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.deserializeBinaryFromReader);
      msg.setDeviceNodeOverrides(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceCloudLog(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.ZeppelinCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.ZeppelinCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceNodeOverrides();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.serializeBinaryToWriter
    );
  }
  f = message.getForceCloudLog();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
fusionMode: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides}
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides;
  return proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides}
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.FusionMode} */ (reader.readEnum());
      msg.setFusionMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFusionMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.FusionMode = {
  DEFAULT: 0,
  FUSION_V2: 1,
  FUSION_V1: 2,
  PEER_CONNECTION: 3
};

/**
 * optional FusionMode fusion_mode = 1;
 * @return {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.FusionMode}
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.prototype.getFusionMode = function() {
  return /** @type {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.FusionMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.FusionMode} value
 * @return {!proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides} returns this
 */
proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides.prototype.setFusionMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional DeviceNodeOverrides device_node_overrides = 1;
 * @return {?proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides}
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.getDeviceNodeOverrides = function() {
  return /** @type{?proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides, 1));
};


/**
 * @param {?proto.skygateway.ZeppelinCloudOverrides.DeviceNodeOverrides|undefined} value
 * @return {!proto.skygateway.ZeppelinCloudOverrides} returns this
*/
proto.skygateway.ZeppelinCloudOverrides.prototype.setDeviceNodeOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.ZeppelinCloudOverrides} returns this
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.clearDeviceNodeOverrides = function() {
  return this.setDeviceNodeOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.hasDeviceNodeOverrides = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool force_cloud_log = 2;
 * @return {boolean}
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.getForceCloudLog = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skygateway.ZeppelinCloudOverrides} returns this
 */
proto.skygateway.ZeppelinCloudOverrides.prototype.setForceCloudLog = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.skygateway);
